import UserAvatar from '@/components/UserAvatar'

export default {
  props: {
    dot: Object,
    mode: String,
    isOnPage: [Boolean, Number],
    isAssignedToCurrentUser: [Boolean]
  },
  components: {
    UserAvatar
  },
  computed: {
    isGeneric() {
      return this.dot.mode === 'CARD_MODE_GENERIC'
    },
    dotBgColor() {
      return `ps-bg-brand-${this.isGeneric ? 'green' : 'orange'}`
    },
    dotOpacity() {
      return this.isOnPage ? null : 'ps-opacity-50'
    },
    card() {
      return this.dot.card
    }
  },
  methods: {
    generateColors(color) {
      return `ps-bg-${color}-100 ps-text-${color}-800`
    }
  }
}
